import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectSessions } from '@/store/slices/project/selectors';

export const useHandleGoToGreenroom = (searchParams?: string) => {
  const params = useParams();
  const sessions = useAppSelector(getWorkingProjectSessions);

  const isSingleSession = sessions && sessions.length === 1;
  const session = isSingleSession ? sessions?.[0] : sessions?.find((s) => s.uuid === params.sessionUuid);

  return useCallback(() => {
    if (!session?.uuid) return;
    const search = searchParams ? `?${searchParams}` : '';
    window.location.href = `${import.meta.env.VITE_GREENROOM_REDIRECT}/create/${session.uuid}${search}`;
  }, [session?.uuid, searchParams]);
};
